import React from 'react';
import { styled } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Colors } from 'library';
import { Link } from 'react-router-dom';

interface RBackLinkProps {
    label: string;
    to: string;
}

export function RBackLink({ label, to }: RBackLinkProps) {
    return (
        <StyledBackLink to={to}>
            <ArrowBack sx={{ fontSize: 18 }} />
            {label}
        </StyledBackLink>
    );
}

const StyledBackLink = styled(Link)({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    color: Colors.mediumGrey,
    textDecoration: 'none',
    padding: 0,
    marginBottom: 8,
    '&:hover': {
        color: Colors.darkNavy,
    },
});
